import { render, staticRenderFns } from "./CompanyUserDialog.vue?vue&type=template&id=37013db7&"
import script from "./CompanyUserDialog.vue?vue&type=script&lang=js&"
export * from "./CompanyUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports